import gql from 'graphql-tag';

export default gql`
  query footerMenu {
    application(name: HOTELONLYBOOKING) {
      bottomMenu {
        id
        title
        ... on ExpandableMenuItem {
          items {
            id
            title
            link {
              title
              target
              ... on AbsoluteLink {
                url
              }
              ... on RelativeLink {
                path
              }
            }
          }
        }
      }
      mediaMenu {
        id
        title
        link {
          title
          target
          ... on AbsoluteLink {
            url
          }
          ... on RelativeLink {
            path
          }
        }
      }
      ... on HotelOnlyBooking {
        translations(language: enUS) {
          ... on HotelOnlyBookingTranslations {
            common {
              copyright
            }
          }
        }
      }
    }
  }
`;
